<template lang="pug">
form(@submit.prevent="submit" name="channel-form" novalidate)
  .modal-card
    header.modal-card-head
      p.modal-card-title(v-once) {{ title }}
    section.modal-card-body.modal-tabs
      b-tabs(
        v-model="activeTab"
        position="is-centered"
        expanded
      )
        b-tab-item(label="Details")
          b-field(label="Title")
            b-input(
              :value="channel.title"
              @input="set($event, 'title')"
            )
          b-field(label="Subtitle")
            b-input(
              :value="channel.sub_title"
              @input="set($event, 'sub_title')"
            )
          //- b-field(label="Short Description")
          //-   b-input(
          //-     type="textarea"
          //-     rows="2"
          //-     :value="channel.short_desc"
          //-     @input="set($event, 'short_desc')"
          //-   )
          b-field(label="Description")
            b-input(
              type="textarea"
              rows="5"
              :value="channel.long_desc"
              @input="set($event, 'long_desc')"
            )
        b-tab-item(label="Cover Art")
          cover-art-tab(
            v-model="artwork"
            :default-image="defaultArtwork"
            @input="a => artwork = a"
          )
        b-tab-item(label="iTunes")
          cover-art-tab(
            v-model="image"
            :default-image="defaultImage"
            :height="293"
            :width="293"
            @input="i => image = i"
          )
          b-field(label="Keywords")
            b-taginput(
              type="is-primary"
              :value="channel.itunes_keywords"
              @input="set($event, 'itunes_keywords')"
              allow-new
            )
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) {{ submitLabel }}
</template>

<script>
import { mapGetters } from 'vuex';
import CoverArtTab from '@/components/form/episode/CoverArtTab';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'channel-form',
  components: {
    CoverArtTab,
  },
  computed: {
    ...mapGetters({
      channel: getters.GET_CHANNEL,
    }),
    defaultArtwork() {
      if (this.channel._embedded.artwork.id) {
        return this.channel._embedded.artwork.file.url;
      }
      return null;
    },
    defaultImage() {
      if (this.channel.itunes_image.id) {
        return this.channel.itunes_image.file.url;
      }
      return null;
    },
    isNew() {
      return this.channel.id === undefined;
    },
    submitLabel() {
      return this.isNew ? 'Save Channel' : 'Save Changes';
    },
    title() {
      return this.isNew ? 'New Channel' : `Edit Channel: ${this.channel.title}`;
    },
  },
  data() {
    return {
      activeTab: 0,
      artwork: null,
      image: null,
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    set(val, key) {
      this.$store.commit(mutations.SET_CHANNEL_FIELD, {
        key,
        val,
      });
    },
    async submit() {
      this.settings.submitting = true;
      const action = this.isNew ? actions.DO_CREATE_CHANNEL : actions.DO_UPDATE_CHANNEL;
      const payload = {
        id: this.channel.id,
        itunes_keywords: this.channel.itunes_keywords.join(','),
        long_desc: this.channel.long_desc,
        short_desc: this.channel.short_desc,
        sub_title: this.channel.sub_title,
        title: this.channel.title,
        zoom: 'artwork',
      };
      if (this.artwork) {
        const file = this.artwork.generateDataUrl('image/jpeg');
        const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
        payload.artwork_id = data.images[0].id;
      }
      if (this.image) {
        const file = this.image.generateDataUrl('image/jpeg');
        const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
        payload.itunes_image_id = data.images[0].id;
      }
      const response = await this.$store.dispatch(action, payload);
      this.$parent.close();
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: response.message,
      });
      setTimeout(() => {
        this.$store.commit(mutations.SET_MEDIA_REFRESH, true);
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/ChannelForm.vue